<template>
  <div id="app">
    <router-view v-if="isRouter" />
  </div>
</template>
<script>
export default {
  data() {
    return {
      isRouter: true,
    };
  },
  provide() {
    return {
      reload: this.reload,
      proIdurl: "",
    };
  },
  mounted() {
    this.setwindow();
  },
  watch: {
    $route(newval, oldval) {
      if (newval.query.proId) {
        this.seturl(newval);
      }
    },
  },
  methods: {
    //判断是不是微信浏览器
    seturl(rou) {
      const query = rou.query;
      if (query.proId) {
        if (localStorage.getItem("promotion")) {
          localStorage.removeItem("promotion");
        }
        this.proIdurl = `?proId=${query.proId}&proType=${query.proType}`;
        localStorage.setItem("promotion", JSON.stringify(query));
      }
    },
    setwindow() {
      const query = this.$route;
      // console.log(query);
      return false;
    },
    reload() {
      this.isRouter = false;
      this.$nextTick(() => {
        this.isRouter = true;
      });
    },
  },
};
</script>
<style lang="less">
@import "./assets/css/base.less";
/* 去掉input尾部上下小箭头 start */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  -o-appearance: none !important;
  -ms-appearance: none !important;
  appearance: none !important;
  margin: 0;
}
input[type="number"] {
  -webkit-appearance: textfield;
  -moz-appearance: textfield;
  -o-appearance: textfield;
  -ms-appearance: textfield;
  appearance: textfield;
}
/* 去掉input尾部上下小箭头 end */
/* tooltip 提示框 effect="light"的情况下的样式 */
.el-tooltip__popper.is-light {
  border-color: #660874 !important;
  // color:#660874 !important;
}
.el-tooltip__popper.is-light .popper__arrow {
  /* 上方箭头 */
  border-top-color: #660874 !important;
  /* 下方箭头 */
  border-bottom-color: #660874 !important;
}
</style>
